import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { AlertCircle, RefreshCw } from "lucide-react";

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryText?: string;
  className?: string;
  hideOnCollapse?: boolean;
  isCollapsed?: boolean;
  variant?: "default" | "destructive" | "warning";
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = "Bir hata oluştu",
  description,
  onRetry,
  retryText = "Tekrar Dene",
  className,
  hideOnCollapse = true,
  isCollapsed = false,
  variant = "destructive",
}) => {
  if (hideOnCollapse && isCollapsed) {
    return null;
  }

  const variantStyles = {
    default: "text-muted-foreground",
    destructive: "text-destructive",
    warning: "text-orange-500",
  };

  return (
    <div
      className={cn(
        "px-2 py-4 text-center text-sm",
        variantStyles[variant],
        className
      )}
    >
      <div className="mb-2 flex justify-center">
        <AlertCircle className="h-4 w-4" />
      </div>

      <p className="font-medium mb-1">{title}</p>

      {description && <p className="mb-3 text-xs opacity-80">{description}</p>}

      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          onClick={onRetry}
          className="text-xs"
        >
          <RefreshCw className="h-3 w-3 mr-1" />
          {retryText}
        </Button>
      )}
    </div>
  );
};
